// Third Party
import cx from 'classnames';
import { twMerge } from 'tailwind-merge';

const getInvalidStylesAsClassName = 'bg-error-light';

const getDisabledStylesAsClassName =
  'bg-gray-xxlight text-gray-main cursor-not-allowed';

const getReadOnlyStylesAsClassName =
  'bg-gray-xxlight cursor-text text-gray-main';

const getNoLabelStylesAsClassName =
  'relative bottom-[7px] placeholder:text-gray-main';

export const getFieldInputStylesAsClassName = (
  isInvalid?: boolean,
  showLabel?: boolean,
  disabled?: boolean,
  readOnly?: boolean
): string => {
  return twMerge(
    cx(
      'block',
      'box-border',
      'w-full',
      'text-primary-main',
      'bg-white',
      // 'font-medium',
      'text-base',
      'leading-10/7',
      'pt-[18px]',
      'px-4',
      'pb-1',
      'cursor-pointer',
      'outline-none',
      'border-0',
      'placeholder-primary-main',
      'duration-200',
      'ease-in-out'
    ),
    cx({ [getReadOnlyStylesAsClassName]: readOnly }),
    cx({ [getInvalidStylesAsClassName]: isInvalid }),
    cx({ [getNoLabelStylesAsClassName]: !showLabel }),
    cx({ [getDisabledStylesAsClassName]: disabled })
  );
};

export const getFieldChevronStylesAsClassName = 'px-0';
